angular
    .module("skillBuilderSaaS")
    .factory("FormSubmitter", ["$rootScope", "$sce", FormSubmitter]);
function FormSubmitter($rootScope, $sce) {
    // Expose our Api
    return {
        submit: submit
    };
    function submit(url, method, params) {
        url = $sce.trustAsResourceUrl(url);
        $rootScope.$broadcast("form.submit", {
            url: url,
            method: method,
            params: params
        });
    }
}
